import {
  Alert,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PaymentCards from "./PaymentCards";
import CustomButton from "../../../reusableComponents/CustomButton";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import "./gatewayStyle.css";
import { colorBrandObject } from "../../../../constants/brandings";

function PaymentOpions(props) {
  const [twocolumns, setTwoColumns] = useState(false);
  const [threecolumns, setThreecolumns] = useState(false);
  const [fourcolumns, setFourcolumns] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1300px)");
    setTwoColumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setTwoColumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1640px)");
    setThreecolumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setThreecolumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1910px)");
    setFourcolumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setFourcolumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  const sortedOptions = [...props.options].sort((a, b) =>
    a.title.localeCompare(b.title)
  );

  return (
    <Card
      style={{
        height: "69px",
        padding: props.toggle ? "14px" : "14px",
        width: "280px",
        border: props.toggle
          ? "3px  solid #CAC9FB"
          : "1px solid rgb(233 223 223)",
        borderRadius: "10px",
        boxShadow: "rgba(0, 0, 0, 0.06) 3px 4px 8px",
      }}
    >
      <FormControl sx={{ width: 240, marginRight: 10, marginBottom: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={props.handleClick}
        >
          <div>
            <div style={{ display: "flex" }}>
              <img src={props.src} />
              <Typography style={{ paddingLeft: "5px" }}>
                {props.title}
              </Typography>
              {props.count > 0 && (
                <TaskAltIcon
                  sx={{
                    color: "rgba(36, 183, 170, 1)",
                    height: "24px",
                    width: "24px",
                  }}
                />
              )}
            </div>
            <p
              style={{
                fontSize: "13px",
                color: "gray",
                paddingLeft: "25px",
              }}
            >
              {" "}
              {props.count} selected{" "}
            </p>
          </div>
          <section
            style={{
              border: "1.2px",
              borderStyle: "solid",
              borderColor: "#0101021F",
              borderRadius: "10px",
              backgroundColor: "white",
              width: "70px",
              height: "29px",
              padding: "2px 0px 0px 9px",
              marginRight: "-9px",
              fontFamily: "Poppins",
              cursor: "pointer",
            }}
            onClick={props.handleClick}
          >
            <img
              style={{ marginTop: "-2px", marginRight: "5px" }}
              src={props.count == 0 ? "/assets/Plus.svg" : "/assets/Edit.svg"}
            />
            {props.count == 0 ? "Add" : "Edit"}
          </section>
        </div>
      </FormControl>
      {props.toggle && (
        <div
          style={{
            width: "100%",
            position: "fixed",
            top: "220px",
            marginLeft: twocolumns
              ? "29%"
              : threecolumns
                ? "23%"
                : fourcolumns
                  ? "21%"
                  : "17%",
          }}
        >
          <Alert
            sx={{
              width: twocolumns
                ? "34%"
                : threecolumns
                  ? "46%"
                  : fourcolumns
                    ? "53%"
                    : "59%",
              fontSize: "12px",
              backgroundColor: "#FEFFE6",
              marginBottom: "20px",
              marginTop: "-36px",
            }}
            icon={false}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <img
                src="/assets/info-circle-yellow.svg"
                style={{ paddingTop: "2px" }}
              />

              <Typography className="alertText">
                {" "}
                Please preview once after adding the payment options which you
                would like to accept for your operations
              </Typography>
            </div>
          </Alert>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: twocolumns
                ? "34%"
                : threecolumns
                  ? "46%"
                  : fourcolumns
                    ? "53%"
                    : "59%",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={props.allChecked}
                  onChange={props.handleAllCheck}
                  sx={{
                    width: "26px", height: "26px", '& .MuiSvgIcon-root': {
                      color: colorBrandObject?.secondaryButtonColor,
                    },
                    '&.Mui-checked': {
                      color: colorBrandObject?.secondaryButtonColor,
                      '& .MuiSvgIcon-root': {
                        fill: colorBrandObject?.secondaryButtonColor,
                      },
                    },
                  }}
                />
              }
            />
            <Typography
              onClick={props.handleAllCheck}
              style={{ marginLeft: "-10px", cursor: "pointer" }}
            >
              Select All
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: twocolumns
                ? "42%"
                : threecolumns
                  ? "53%"
                  : fourcolumns
                    ? "58%"
                    : "68%",
              height: "34vh",
              overflowY: "auto",
              borderColor: "#0101021F",
              padding: "2px",
            }}
          >
            {sortedOptions?.map((obj) => (
              <PaymentCards
                obj={obj}
                allChecked={props.allChecked}
                count={props.count}
                setCount={props.setCount}
                selects={props.selects}
                setSelects={props.setSelects}
                clickedAll={props.clickedAll}
                handleAllCheck={props.handleAllCheck}
                paymentOptionsIds={props.paymentOptionsIds}
                pspCode={props.pspCode}
              />
            ))}
          </div>

          <div
            style={{
              padding: "25px 0px 0 244px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: twocolumns
                ? "33%"
                : threecolumns
                  ? "46%"
                  : fourcolumns
                    ? "53%"
                    : "59%",
            }}
          >
            <CustomButton
              text={"Done"}
              type={"primary"}
              variant={"contained"}
              onClick={props.handleClick}
            />
          </div>
        </div>
      )}
    </Card>
  );
}

export default PaymentOpions;
